module.exports = "/packs/images/homepage/activity/performing_arts_desktop~5e3b37540520ae6e1f988fccf77b3388.jpg";